<template>
  <RuleCommon>
    <p>
      {{ $t('1、通过聊天获得积分，积分达到一定等级后，可获得额外的积分奖励') }}
    </p>
    <p v-for="(item, index) in list" :key="index">
      {{
        $t('聊满x积分，额外奖励w积分', {
          chatUseGold: item.chatUseGold,
          rewardGold: item.rewardGold
        })
      }}
    </p>
    <p>
      {{
        $t('2、每达到可领取积分奖励的等级后，点击“领取”即可获得额外的积分奖励')
      }}
    </p>
    <p>
      {{ $t('3、活动期间，每日0点更新当天的任务') }}
    </p>
    <p>
      {{ $t('4、收获礼物而获得的积分，不在此计算中') }}
    </p>
    <p>
      {{
        $t(
          '5、该活动意在鼓励大家文明积极聊天，一旦发现不符合平台规范的行为，一经平台发现，将扣除全部获得的积分奖励'
        )
      }}
    </p>
  </RuleCommon>
</template>

<script>
import { apiGetTasks } from '@/api'
import RuleCommon from './RuleCommon.vue'

export default {
  components: {
    RuleCommon
  },
  data() {
    return {
      list: []
    }
  },
  async created() {
    const { data } = await apiGetTasks()
    this.list = data || []
  }
}
</script>

<style lang="scss" scoped>
.chat-rule {
  padding: 16px 14px 0;
  font-size: 14px;
  color: rgba(51, 51, 51, 0.8);
  line-height: 17px;
  .chat-rule-title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 19px;
    .icon {
      display: inline-block;
      width: 4px;
      height: 16px;
      background: #fd4879;
      margin-right: 3px;
    }
  }
  p {
    margin-top: 8px;
  }
}
</style>
